import React from "react";
import { dataStore } from "../../services/storage/DataStore";
import './CatalogToggleSwitch.css';

export class CatalogToggleSwitch extends React.Component<any, any>{
    constructor(props: any){
        super(props);
        this.state = {
            checked: false,
            first: "",
            second: ""
        };
    }

    componentDidMount(){
        this.setState({first: this.props.first});
        this.setState({second: this.props.second});
        if(this.props.defaultValue){
            this.setState({checked: this.props.defaultValue}, () => {
                this.props.notifyChanges(this.state.checked);
            });
        } else {
            this.setState({checked: false}, () => {
                this.props.notifyChanges(this.state.checked);
            });
        }
    }

    handleChange(){
        this.setState({checked: !this.state.checked}, () => {
            dataStore.publishTabSelectionData(this.state.checked);
            this.props.notifyChanges(this.state.checked);
        });
    }

    render(){
        return <div className={"switch"}>
            <label>
                <input type="checkbox" checked={this.state.checked} onChange={() => this.handleChange()}></input>
                <div className={"slider round"}>
                    {this.state.first && <span className={"first-element"} style={
                        {color: !this.state.checked ? "#FFFFFF" : "#2D32AA", fontWeight: !this.state.checked ? 600 : 500}}>{this.state.first}</span>}
                    {this.state.second && <span className={"second-element"} style={
                        {color: this.state.checked ? "#FFFFFF" : "#2D32AA", fontWeight: this.state.checked ? 600 : 500}}>{this.state.second}</span>}
                </div>
            </label>
        </div>
    }

}